import { Route, Redirect } from 'react-router-dom'
import { useLandingContext } from '../Context'


type RotaProps ={
    component: any,
    isPrivate: boolean,
    isExceptionPrivate?: boolean,
    exact?: boolean,
    path: string
}

function Rota({
    component: Component,
    isExceptionPrivate,
    isPrivate,
    ...rest
}:RotaProps){
    
    const useContext = useLandingContext()

    if(!useContext.signed && isPrivate){
        return <Redirect to="/private/login"/>
    }

    if(isExceptionPrivate && useContext.signed){
        return <Redirect to="/dashboard/configuracoes"/>
    }
    
    return(
        <Route { ...rest } render={ (props) =>{
            return <Component {...props} />
        }}/>
    )
}

export default Rota